@charset "UTF-8";

/* src/app/core/loading/loading.component.scss */
.spinner-container {
  position: fixed;
  background: #ffffff;
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  border: 2px solid #ef6a1d;
  height: 42px;
  width: auto;
  max-width: 320px;
  border-radius: 21px;
  padding: 0 16px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  bottom: 50px;
  left: 27px;
  z-index: 9999;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transition: all 0.2s ease-in-out;
  animation: slideInUp 0.25s ease-out;
}
.spinner-orange {
  color: #ef6a1d;
  font-size: 16px;
  flex-shrink: 0;
}
.loading-text {
  color: #333333;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.01em;
  white-space: nowrap;
  font-family: sans-serif;
  text-transform: uppercase;
}
@keyframes slideInUp {
  from {
    transform: translate3d(0, 15px, 0);
    opacity: 0;
  }
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}
/*# sourceMappingURL=loading.component-ML6VET33.css.map */
